'use strict';

window.ranger = window.ranger || {};

/**
 * Handles uploads of new pics.
 */
ranger.Range = class {

  /**
   * Inititializes the range creation.
   * @constructor
   */
  constructor() {
    ranger.auth.waitForAuth.then(() => {
    // Firebase SDK
    this.database = firebase.database();
    this.auth = firebase.auth();
    let dragSrcElement = null;

    /*** Drag Ordering ***/
    this.allowDrop = function(event) {
      event.preventDefault();
    }
    this.drag = function(event) {
      dragSrcElement = event.srcElement;
    }
    this.drop = function(event) {
      event.preventDefault();
      var dropElement = event.target
      dropElement.parentNode.insertBefore(dragSrcElement, dropElement);
      //var data = event.dataTransfer.getData("text");
      //event.target.appendChild(document.getElementById(data));
      ranger.range.saveSort();
    }

    //Variables
    let handHighlightColor = 'mdl-color--green';
    let editID = '';
    let isMouseDown = false;
    this.colors = 'mdl-color--green mdl-color--amber mdl-color--red mdl-color--blue mdl-color--lime \
mdl-color--cyan mdl-color--brown mdl-color--grey mdl-color--teal mdl-color--indigo mdl-color--purple \
mdl-color--pink mdl-color--light-green mdl-color--orange mdl-color--deep-orange mdl-color--deep-purple';
  let classCells = `.mdl-color--green, .mdl-color--amber, .mdl-color--red, .mdl-color--blue, .mdl-color--lime,
.mdl-color--cyan, .mdl-color--brown, .mdl-color--grey, .mdl-color--teal, .mdl-color--indigo, mdl-color--purple,
.mdl-color--pink, .mdl-color--light-green, .mdl-color--orange, .mdl-color--deep-orange, .mdl-color--deep-purple`;
    this.colorArray = ['mdl-color--green', 'mdl-color--amber', 'mdl-color--red', 'mdl-color--blue', 'mdl-color--lime', 'mdl-color--cyan', 'mdl-color--brown', 'mdl-color--grey',
    'mdl-color--teal', 'mdl-color--indigo', 'mdl-color--purple', 'mdl-color--pink', 'mdl-color--light-green', 'mdl-color--orange', 'mdl-color--deep-orange', 'mdl-color--deep-purple'];
    let colorList = this.colors;
    let filteredList = 'mdl-color--amber mdl-color--red mdl-color--blue mdl-color--lime mdl-color--cyan \
mdl-color--brown mdl-color--grey mdl-color--teal mdl-color--indigo mdl-color--purple mdl-color--pink \
mdl-color--light-green mdl-color--orange mdl-color--deep-orange mdl-color--deep-purple';

    window.postKey;
    window.rangeKey;
    window.replayerKey = '';
    window.removal = [];

    $('.boardRemoval').blur(function() {
      var cardValue = $(this).val();
      if($(this).val() != '') {
        window.removal[$(this).data('id')] = cardValue.substring(0, 1);
        ranger.range.updatePercent();
        $('.noRemoval').hide();
        $('.wRemoval').show();
      } else {
          var cardIndex = $(this).data('id');
          window.removal.splice(cardIndex, 1);
          if(window.removal.length < 1) {
            $('.noRemoval').show();
            $('.wRemoval').hide();

          }
      }
    });

    $(document).ready(() => {
      // DOM Elements
      this.addButton = $('#startNewHand');
      this.overlay = $('.fp-overlay', '#page-tableRange');
      this.colorSelect = $('.colorSelect')
      this.newPictureContainer = $('#tableRange');
      this.saveColorNameBtn = $('#saveColorName');
      this.clearColorBtn = $('#clearColor');
      this.cancelColorNameBtn = $('#cancelColorName');
      this.saveColorNameInput = $('#colorNameLabel');
      this.toast = $('.mdl-js-snackbar');
      this.combosBreakDown = $('.combosBreakdown');
      this.cell = $('.cell');
      this.resetGrid = $('#eraserBtn');
      this.handInfo = $('#handInfo');
      this.rangeTitle = $('#rangeTitle');
      this.saveRangeBtn = $('#saveRangeBtn');
      this.filterBtn = $('#newFilter_btn');
      this.saveFilterBtn = $('#saveFilter');
      this.updateFilterBtn = $('#updateFilter');
      this.duplicateFilterBtn = $('#duplicateFilter');
      this.cancelFilterBtn = $('#cancelFilter');
      this.filterName = $('#filterInput');
      this.deleteRangeBtn = $('#deleteRange');
      this.addComment = $('#addComment');
      this.saveComment = $('#saveComment');
      this.cancelComment = $('#cancelComment');
      this.commentInput = $('#commentInput');
      this.shareRange = $('#shareRange');
      this.handTextArea = $('#handTextArea');
      this.compareRangeBtn = $('#compareRangeBtn');
      this.compareRangeForm = $('#compareRangeForm');
      this.calculateEquityBtn = $('#calculateEquityBtn');
      this.closeEquityCalc = $('#closeEquityCalc');
      this.importRangeBtn = $('#importColor');
      this.submitImport = $('#submitImport');
      this.coachFeed = $('#coachFeed');
      this.coachModal = $('.coachingHand');
      this.closeCoachModal = $('.cancelCoaching');
      this.coachingAnswer = [];
      this.createCoachingHand = $('#createCoachingHand');
      this.shareCoaching = $('.shareCoaching');
      this.categories = $('#categories');
      this.closeCategory = $('#closeCategory');
      this.categoriesForm = $('#categoriesForm');
      this.saveCategory = $('#saveCategory');
      this.rangeNotes = $('#rangeNotes');
      this.deleteCoachingHand = $('#deleteCoachingHand');


      //Group
      this.shareToGroup = $('#shareToGroup');
      this.cancelGroup = $('#cancelGroup');
      this.searchResults = $('#shareGroupResults');
      this.userSearchInput = $('#searchGroup');
      this.userSearchInput.keyup(() => this.searchUsersFunction());
      this.userSearchInput.focus(() => this.searchUsersFunction());
      this.userSearchInput.click(() => this.searchUsersFunction());

      $('#shareGroupResults').on('click', 'a', function() {
          ranger.firebase.addMember(window.postKey, $(this).data('id'), $(this).data('name'));

          ranger.firebase.shareToFeed(window.postKey, $(this).data('id'));
      });

      $('.rangeMemberList').on('click', '.btn', function() {
         ranger.firebase.removeMember(window.postKey, $(this).data('id'));
         ranger.firebase.removeFromFeed(window.postKey, $(this).data('id'));
      });

      $('#copyAnalysisBtn').click(function() {
        var items = $('.cell').not(classCells);

        items.each(function() {
          if ($(this).children().length > 0) {

          } else {
            $(this).toggleClass('invisible');
          }
        });

        ranger.range.updatePercent(false, true);
      })


$('.editResults').on('click', function() {
    $('#handInfo').attr('contentEditable', 'true');
    $('#handInfo').focus();
    var data = {
      message: 'Use Forum Format To Paste In Hand From PT4 or HM2',
      timeout: 8000,
      class: 'alert-warning'
    };
    returnToast(data);
});

$('span.showdown').hide();

$('body').on('click', '#showdown', function() {
   $('.showdown').toggle();
});


      // Event bindings
      this.addButton.click(() => this.initiateNewRange());
      this.colorSelect.dblclick(() => this.changeColorName());
      this.saveColorNameBtn.click(() => this.saveColorName(editID));
      this.clearColorBtn.click(() => this.clearSelectedColour(editID));
      this.cancelColorNameBtn.click(() => this.cancelColorName(editID));
      this.cell.mouseup(() => this.updatePercent());
      this.resetGrid.click(() => this.clearGrid(true));
      this.handInfo.blur(() => this.updateFormatting());
      this.saveRangeBtn.click(() => this.createRange());
      this.filterBtn.click(() => this.newFilterButton());
      this.saveFilterBtn.click(() => this.saveFilterButton());
      this.updateFilterBtn.click(() => this.saveFilterButton(true));
      this.duplicateFilterBtn.click(() => this.duplicateFilter());
      this.cancelFilterBtn.click(() => this.cancelFilterButton());
      this.rangeTitle.blur(() => this.updatePost());
      this.deleteRangeBtn.click(() => this.deleteRange());
      this.addComment.click(() => this.addCommentFunction());
      this.saveComment.click(() => this.saveCommentFunction());
      this.cancelComment.click(() => this.cancelCommentFunction());
      this.shareToGroup.click(() => this.showGroupFunction());
      this.cancelGroup.click(() => this.cancelGroupFunction());
      this.handTextArea.blur(() => this.formatHand());
      this.compareRangeBtn.click(() => this.compareRanges());
      this.calculateEquityBtn.click(() => this.calculateEquity());
      this.closeEquityCalc.click(() => this.compareRangeForm.hide());
      this.importRangeBtn.click(() => this.importRangeShow(handHighlightColor));
      this.submitImport.click(() => this.importRangeFunction(handHighlightColor));
      this.coachFeed.click(() => this.makeCoachingHand());
      this.closeCoachModal.click(() => this.coachModal.hide());
      this.createCoachingHand.click(() => this.saveCoachingHand());
      this.categories.click(() => this.showCategories());
      this.closeCategory.click(() => this.categoriesForm.modal('hide'));
      this.saveCategory.click(() => this.addCategory());
      this.rangeNotes.blur(() => this.saveNotes());

      $('#cancel').click(function() {
          $('.import-wrapper').hide();
      });
      this.clipboard = new Clipboard('#shareRange', {
          text: function() {
              return 'https://crushwithus-70cb5.firebaseapp.com/viewPost/' + window.postKey;
          }
      });

      this.coachClipboard = new Clipboard('.shareCoaching', {
          text: function() {
              return 'https://crushwithus-70cb5.firebaseapp.com/quiz/' + window.postKey;
          }
      });

      this.coachClipboard.on('success', function(e) {
        var data = {
          title: '',
          class: 'alert-success',
          href: '',
          actionText: '',
          message: 'Quiz Link Copied',
          timeout: 3000
        };
        //ranger.range.toast[0].MaterialSnackbar.showSnackbar(data);
        returnToast(data, 3000);
      });

      this.clipboard.on('success', function(e) {
        var data = {
          title: '',
          class: 'alert-success',
          href: '',
          actionText: '',
          message: 'Link Copied To Clipboard',
          timeout: 3000
        };
        //ranger.range.toast[0].MaterialSnackbar.showSnackbar(data);
        returnToast(data, 3000);
      });

      var isHighlighted;
      $(".cell")
        .mousedown(function() {
          isMouseDown = true;
          if($('#sliderWeighting').val() == 100) {
              $(this).children('.weighted').each(function() {
                 this.remove();
              });
              $(this).removeClass(filteredList);
              $(this).toggleClass(handHighlightColor);
              isHighlighted = $(this).hasClass(handHighlightColor);
          } else  if ($('#sliderWeighting').val() < 100) {
              if ($(this).children('.' + handHighlightColor).length > 0) {
                  $(this).children('.' + handHighlightColor).remove();
              } else {
              var weight = $('#sliderWeighting').val();
              var weightedDiv = $('<div>');
              $(this).removeClass(colorList);
              weightedDiv.addClass(handHighlightColor + ' weighted');
              weightedDiv.attr('data-weight', weight);
              weightedDiv.attr('data-hand', $(this).text());
              weightedDiv.width(weight + '%');
              var start = 0;
              $(this).children('.weighted').each(function() {
                  start+= parseInt(this.getAttribute('data-weight'));
              });
                  if ((parseInt(start) + parseInt(weight)) <= 100) {
                    start = start + '%';
                    weightedDiv.css('left', start);
                    $(this).prepend(weightedDiv);
                  } else {
                      swal(
                      'Oops...',
                      'Weights cannot total more than 100',
                      'error'
                      )
                  }
              }

          } else {

          }
          return false; // prevent text selection
        })
        .mouseover(function() {
          if (isMouseDown) {
            if($('#sliderWeighting').val() == 100) {
                $(this).removeClass(filteredList);
                $(this).toggleClass(handHighlightColor, isHighlighted);
            } else {

            }
          }
        })
        .bind("selectstart", function() {
          return false;
        })
        .mouseup(function() {
            isMouseDown = false;
        })


        $('#handInfo').on('click', '#hhTitle', function() {
          //window.open('https://replayer.raiseyouredge.com/' + window.replayerKey);
        });

        $('.colorSelect').click(function() {
           editID = $(this).attr('id');

           handHighlightColor = editID;
           filteredList = colorList.replace(handHighlightColor, '');
        });

        $('#public_tgl').change(function() {
           ranger.firebase.setPublic(window.postKey);
        });

        $('.filters').on('click', '.filterbtns', function() {
            $('.filterbtns').removeClass('selectedFilter');
            window.rangeKey = $(this).attr('id');
            $(this).addClass('selectedFilter');
            if ($(this).attr('data-notes')) {
              $('#rangeNotes').html($(this).attr('data-notes'));
            } else {
              $('#rangeNotes').html('');
            }

            $('.invisible').removeClass('invisible');
            ranger.firebase.loadRange(window.postKey, window.rangeKey);
        });

        $('.filters').on('dblclick', '.filterbtns', function() {
            $('#filterNameForm').modal('show');
            $('#filterInput').focus();
            $('#saveFilter').hide();
            $('#updateFilter').show();
            $('#duplicateFilter').show();
        });

        var timeoutHold = 0
        var mobileColorChange = function() {
          $('#colorModal').modal('show');
          $('#colorNameLabel').focus();
        }
        $('.colorSelect').mousedown(function() {
          timeoutHold = setTimeout(mobileColorChange, 1200)
        }).bind('mouseup mouseleave', function() {
          clearTimeout(timeoutHold);
        });

        /***** Quiz Functions *****/
        $('#addmcAnswer').click(function() {
          var answer = $('#mcAnswer').val();
          if (answer != '') {
            //Add Feature on click handler
          $('#mcAnswer').val('');
            var html = `<li class="list-group-item">${answer}</li>`;
            $('.quizQuestionAnswers').append(html);
          }
        })

        /** Quiz Hands **/
        $('.quizQuestionAnswers').on('click', 'li', function() {
          $('.mcCorrectAnswer').removeClass('mcCorrectAnswer');
          $(this).toggleClass('mcCorrectAnswer');
        });
        $('.mc-only').hide();
        $('#coachingQuestionType').on('change', function() {
          $('.quizQuestionAnswers').empty();
          if(this.value === 'radio') {
            $('.mc-only').show();
            $('.ha-only').hide();
          } else if (this.value === 'rangeBreakdown') {
            $('.ha-only').show();
            $('.mc-only').hide();
          } else if (this.value === 'rangeDynamic') {
            $('.mc-only').hide();
            $('.ha-only').show();
            $('.hh').hide();
          }
        });

        $('#loadQuestionSelect').on('change', function() {
          var type = $(this).val();
          if (type === 'new') {
            $('#coachingQuestionType').val('rangeDynamic').trigger('change');
            $('#coachQuestion').val('');
            $('#coachReason').val('');
            $('#questionOrderInput').val('');
            $('#questionIsProInput').attr('checked', false);
            $('#deleteCoachingHand').addClass('disabled');
          } else {
            ranger.range.loadQuizQuestion(type);
            $('#deleteCoachingHand').removeClass('disabled');
          }

        });

        this.deleteCoachingHand.click(() => this.deleteCoachingQuestions());
        /***** End Quiz Hands ******/

        $('.commentSection').on('click', '.comment-delete', function() {
           ranger.range.deleteCommentFunction($(this).data('id'));
            console.log('deleted ' + $(this).data('id'));
        });

        $('.commentSection').on('click', '.comment-edit', function() {
           window.commentID = $(this).data('id');
            $('div[data-id="'+window.commentID+'"] .mdl-card__supporting-text').attr('contenteditable', 'true').focus();
        });

        $('.commentSection').on('blur', '.mdl-card__supporting-text', function() {
            ranger.firebase.updateComment(window.postKey, window.commentID, $(this).html());
            $('div[data-id="'+window.commentID+'"] .mdl-card__supporting-text').attr('contenteditable', 'false');
        });

        $('.doneReset').click(function() {
          $('#loadQuestionSelect').val('new').trigger('change');
        });

        $('.rangesList').on('click', 'button', function(e) {
          e.preventDefault();
          ranger.range.showCoachRanges($(this).data('id'));
        });

        $('.rangeSections').on('click', 'li', function() {
          $(this).toggleClass('selectedRange');
        })
    });
    }); // end wait for auth
  }

    resetTool() {
        this.clearGrid();
        $('.invisible').removeClass('invisible');
        $('.modal').hide();
        $('.filters').empty();
        $('#handInfo').html('');
        $('#handPreview').html('');
        $('.owner').show();
        this.rangeTitle.val('');
        this.saveRangeBtn.hide();
        $('.comment').remove();
        $('#handTextArea').show();
        $('.rangeMemberList').empty();
    }

    stopListeners() {
        this.database.ref(`/comments/${window.postKey}`).off();
        this.database.ref(`/posts/${window.postKey}/members`).off();
        this.database.ref(`/people/${this.auth.currentUser.uid}/categories`).off();
        this.database.ref(`/posts/${window.postKey}/categories`).off();
        this.database.ref(`/filters/${window.postKey}`).off();
        $('.categoryChips').empty();
        $('.rangeMemberList').empty();
        $('.postCategories').empty();
    }
    startListeners() {
        this.database.ref(`/comments/${window.postKey}`).on('child_added', commentData => {
            this.commentAddHtmlFunction(commentData.key, commentData.val().text, commentData.val().author);
        });
        this.database.ref(`/comments/${window.postKey}`).on('child_removed', commentData => {
            $('div[data-id="' + commentData.key + '"]').remove();
        });
        this.database.ref(`/posts/${window.postKey}/members`).on('child_added', memberData => {
            this.addMemberHTML(memberData.key, memberData.val());
        });
        this.database.ref(`/posts/${window.postKey}/members`).on('child_removed', memberData => {
            //$('.rangeMemberList').empty();
            console.log(memberData.key);
        });
        this.database.ref(`/posts/${window.postKey}/categories`).on('child_added', categoryData => {
          var html = `<span data-id="${categoryData.key}" class="btn btn-outline-secondary">${categoryData.val()}<i class="material-icons">cancel</i></span>`;

          $('.categoryChips').append(html);
        });
        this.database.ref(`/posts/${window.postKey}/categories`).on('child_removed', categoryData => {
          console.log('deleted ' + categoryData.key);
        });

        this.database.ref('/filters/'+window.postKey).orderByChild('sort').on('child_added', function(data) {
          var rangeNotes = '';
              if (data.val().notes) {
                rangeNotes = data.val().notes;
                $('#rangeNotes').html(data.val().notes);
              }
             if (data.val().name) {
               var html = '<button id="'+data.key+'" data-notes="'+rangeNotes+'" class="filterbtns btn btn-warning btn-sm" draggable="true" ondragstart="ranger.range.drag(event)">'+data.val().name+'</button>';
               $('.filters').append(html);
             }
        }, function(error) {
          alert('Upgrade to view Coaching Hands');
        });
        this.database.ref('/filters/'+window.postKey).on('child_removed', function(data) {
            $('button#'+data.key).remove();
        }, function(error) {
          alert('Upgrade to view Coaching Hands');
        });

        ranger.category.startCategoryListeners();
        this.database.ref(`/people/${this.auth.currentUser.uid}/categories`).on('child_removed', memberData => {
          $(`#${memberData.key}`).remove();
          $('div[data-selector="' + memberData.key + '"]').remove();
        })
    }

    /*** Sortying **/
    saveSort() {
      $.each($('.filters').children(), function(index, element) {
        //send to db name: name | sort: sort
        ranger.firebase.saveMiscFeatures(window.postKey, element.getAttribute('id'), index +1);
      });
    }

    /**
   * change page
   */
  initiateNewRange() {
    this.resetTool();
    window.postKey = ranger.firebase.createNewPost();
    page('/addPost');

    $('.rangeTitleContainer').addClass('is-dirty');
    this.rangeTitle.val('Post from - ' + this.auth.currentUser.displayName);
    this.filterName.val('Hero');
    this.saveFilterButton();
      this.stopListeners();
    this.startListeners();
    $('.filterbtns').addClass('selectedFilter');
      $('span.showdown').hide();

  }
/***** Categories *****/
showCategories() {
  $('#categoriesForm').modal('show')
  /*firebase.database().ref(`/posts/${window.postKey}`).orderByChild('categories').equalTo('-LIRsyV7TLbuplzpHUtL').on("value", function(data) {
    console.log('Key - ' + data.key + ' | ' + data.val())
  });*/
}

addCategory() {
  var data = $('#categoryInput').val().toUpperCase();
  $('#categoryInput').val('');
  firebase.database().ref('/people/'+this.auth.currentUser.uid + '/categories/').push(data);
}
savePostCategory(id, name) {
  firebase.database().ref(`/posts/${window.postKey}/categories/`).update({[id]: name});
  firebase.database().ref(`/people/${this.auth.currentUser.uid}/categoryFeed/${id}`).update({[window.postKey]: true});
}
removePostCategory(id) {
  firebase.database().ref(`/posts/${window.postKey}/categories/${id}`).remove();
  firebase.database().ref(`/people/${this.auth.currentUser.uid}/categoryFeed/${id}/${window.postKey}`).remove();
}
/***** Coaching Questions ******/
loadRanges() {
  $('#hh').val(window.replayerKey).parent().addClass('is-dirty');
  firebase.database().ref('/filters/'+window.postKey).once('value').then(function(data) {
    var filters = data.val();
    $('.rangesList').empty()
    $.each(filters, function(key, value) {
        if (filters[key].name) {
          $('.rangesList').append('<button data-id="'+key+'" class="btn btn-warning btn-sm">'+value.name+'</button>');
        }
    });
  });
}
loadCoachingHand() {
    var options = [];
    $('#loadQuestionSelect').empty();
    $('#loadQuestionSelect').append('<option value="new">New</option>');
    firebase.database().ref(`quizzes/${window.postKey}`).orderByChild('sort').on('child_added', function (data) {
          $('#loadQuestionSelect').append(`<option value='${data.key}'>${data.val().question}</option>`);
    });
}
deleteCoachingQuestions() {
  var questionID = $('#loadQuestionSelect').val();
  firebase.database().ref('/quizzes/'+window.postKey+'/'+questionID).remove();
  $('#loadQuestionSelect').val('new').trigger('change');
  ranger.range.loadCoachingHand();
}
saveCoachingHand() {
  var ranges = [];
  var answer = '';
  var questionType = $('#coachingQuestionType').val();
  if (questionType === 'radio') {
    var correct = $('li').index($('li.mcCorrectAnswer')) || '0';
    var quizAnswers = $('.quizQuestionAnswers li');
    $(quizAnswers).each(function(index, item) {
      if(index === (quizAnswers.length - 1)) {
        answer+= $(this).text();
      } else {
        answer+= $(this).text()+',';
      }
    })
    var answerArray = answer.split(',');
    //ranges.push(answer);

    var question = {
      question: $('#coachQuestion').val(),
      answers: answerArray, //add answers
      correctAnswer: correct,
      reason: $('#coachReason').val(),
      type: 'radio',
      sort: parseInt($('#questionOrderInput').val()),
      isPro: $('#questionIsProInput').prop('checked')
    };
  } else if (questionType === 'rangeBreakdown') {
    var quizAnswers = $('.selectedRange');
    quizAnswers.each(function(index, item) {
      if(index === (quizAnswers.length - 1)) {
        answer += $(this).data('answer');
      } else {
        answer += $(this).data('answer')+',';
      }
    })
    var answerArray = answer.split(',');
    ranges.push(answer);
    var question = {
      question: $('#coachQuestion').val(),
      answers: ranges,
      correctAnswer: [0],
      reason: $('#coachReason').val(),
      hh: $('#hh').val(),
      type: 'handBreakdown',
      sort: parseInt($('#questionOrderInput').val()),
      isPro: $('#questionIsProInput').prop('checked')
    };
  } else if (questionType === 'rangeDynamic') {
    var quizAnswers = $('.selectedRange');
    quizAnswers.each(function(index, item) {
      if(index === (quizAnswers.length - 1)) {
        answer += $(this).data('answer');
      } else {
        answer += $(this).data('answer')+',';
      }
    })
    var answerArray = answer.split(',');
    ranges.push(answerArray);
    var question = {
      question: $('#coachQuestion').val(),
      answers: ranges,
      correctAnswer: [0],
      reason: $('#coachReason').val(),
      type: 'rangeDynamic',
      sort: parseInt($('#questionOrderInput').val()),
      isPro: $('#questionIsProInput').prop('checked')
    };
  }

  /** Error with ARRAY Loading in QUIZ **/
  var questionID = $('#loadQuestionSelect').val();
  if (questionID == 'new') {
    firebase.database().ref('/quizzes/'+window.postKey).push(question);
    firebase.database().ref('/coach/'+window.postKey).update({
      author: {name: this.auth.currentUser.displayName, uid: this.auth.currentUser.uid},
      title: this.rangeTitle.val()
    });
  } else {
    firebase.database().ref('/quizzes/'+window.postKey+'/'+questionID).update(question);
  }
  $('.quizSuccessPost').show().fadeIn().delay(1200).fadeOut();
  $('#loadQuestionSelect').val('new').trigger('change');
}

/*** save Range Notes ***/
saveNotes() {
  //$('#'+window.rangeKey).attr('data-notes', this.rangeNotes.html());
  ranger.firebase.saveMiscFeatures(window.postKey, window.rangeKey, '', this.rangeNotes.html());
}


showCoachRanges(filterId) {
  $('.rangeSections').empty();

  firebase.database().ref('/ranges/'+window.postKey+'/'+filterId).once('value').then(function(data) {
    if (data.val().category1) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--green'], data.val().category1));
    }
    if (data.val().category2) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--amber'], data.val().category2));
    }
    if (data.val().category3) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--red'], data.val().category3));
    }
    if (data.val().category4) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--blue'], data.val().category4));
    }
    if (data.val().category5) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--lime'], data.val().category5));
    }
    if (data.val().category6) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--cyan'], data.val().category6));
    }
    if (data.val().category7) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--brown'], data.val().category7));
    }
    if (data.val().category8) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--grey'], data.val().category8));
    }
    if (data.val().category9) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--teal'], data.val().category9));
    }
    if (data.val().category10) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--indigo'], data.val().category10));
    }
    if (data.val().category11) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--purple'], data.val().category11));
    }
    if (data.val().category12) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--pink'], data.val().category12));
    }
    if (data.val().category13) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--light-green'], data.val().category13));
    }
    if (data.val().category14) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--orange'], data.val().category14));
    }
    if (data.val().category15) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--deep-orange'], data.val().category15));
    }
    if (data.val().category16) {
      $('.rangeSections').append(returnList(data.val().buttons['mdl-color--deep-purple'], data.val().category16));
    }
  });
}

makeCoachingHand() {
  /*this.database.ref('/posts/'+window.postKey).update({
       coach: true
   });
   this.database.ref('/coach/'+window.postKey).update({
     author: {
       uid: this.auth.currentUser.uid,
       displayName: this.auth.currentUser.displayName
     }
   })*/
   ranger.range.loadCoachingHand();
   $('.rangeSections').empty();
   $('.quizQuestionAnswers').empty();
   $('.coachingHand').modal();

   ranger.range.loadRanges()
}
loadQuizQuestion(questionID) {
  $('.rangeSections').empty();
  $('.quizQuestionsAnswers').empty();
  if (questionID != 'new') {
    this.database.ref(`quizzes/${window.postKey}/${questionID}`).once('value').then(function(data) {
      var rangeAnswers = false;
      $('#coachingQuestionType').val(data.val().type).trigger('change');
      $('#coachQuestion').val(data.val().question);

      $.each(data.val().answers, function(index, value) {
        if(Array.isArray(value)) {
          rangeAnswers = true;
        } else {
          //html += `<input class="form-group" value="${value}">`;
          console.log(data.val().correctAnswer);
          if (data.val().correctAnswer == index) {
            var selectedAnswer = 'mcCorrectAnswer';
          } else {
            var selectedAnswer = ''
          }
          $('.quizQuestionAnswers').append(`<li class="list-group-item ${selectedAnswer}">${value}</li>`).show();
        }
      });

      $('#coachReason').val(data.val().reason);
      $('#questionOrderInput').val(data.val().sort);
      $('#questionIsProInput').attr('checked', data.val().isPro);
      if (rangeAnswers) {
        ranger.range.loadRanges()
      }
    })
  } else {
    $('.newQuestion').show();
  }
}

/***** GROUP *****/
showGroupFunction() {
    //var role = ranger.MaterialUtils.checkRole();
    //role.then(function(data) {
        if(this.auth.currentUser.isPro === true) {
            $('#groupForm').modal('show');
        } else {
            ranger.MaterialUtils.upgrade();
        }
      //});
}

searchUsersFunction() {
    const searchString = this.userSearchInput.val().toLowerCase().trim();
    if (searchString.length >= ranger.Search.MIN_CHARACTERS) {
      ranger.firebase.searchUsers(searchString, ranger.Search.NB_RESULTS_LIMIT).then(
          results => {
            this.searchResults.empty();
            const peopleIds = Object.keys(results);
            if (peopleIds.length > 0) {
              this.searchResults.fadeIn();
              $('html').click(() => {
                $('html').unbind('click');
                this.searchResults.fadeOut();
              });
              peopleIds.forEach(peopleId => {
                const profile = results[peopleId];
                this.searchResults.append(
                    ranger.Search.createMemberSearchResultHtml(peopleId, profile));
              });
            } else {
              this.searchResults.fadeOut();
            }
          });
    } else {
      this.searchResults.empty();
      this.searchResults.fadeOut();
    }
}
/***** IMPORT *****/
importRangeShow(color) {
    $('#colorModal').modal('hide');
    $('#importHands').modal('show');
    $('#textImportRange').focus();
}
importRangeFunction(color) {
$('#importHands').hide();
    var data = $('#textImportRange').val();
    $('#textImportRange').val('');

    $('.cell').removeClass(color);
    $('.' + color + '.weighted').remove();
    /*var data = 'AA,KK:0.5,55,44,33,22,AKs:0.8,AQs:0.8,AJs:0.8,ATs:0.8,A9,A8,A7,A6,A5,A4,A3,A2,KQs:0.8,KJs:0.8,KJo,KTs:0.8,KTo,K9,K8s,K8o:0.2,K7,K6,K5,K4,K3,K2,QJs:0.8,QJo,QT,Q9,Q8s,Q8o:0.2,Q7,Q6,Q5,Q4,Q3,Q2,JT,J9,J8s,J8o:0.2,J7,J6,J5s:0.2,J4s:0.2,J3s:0.2,J2s:0.2,T9,T8s,T8o:0.2,T7,T6,T5s:0.2,T4s,T3s:0.2,T2s:0.2,98s,98o:0.2,97,96,95s:0.2,95o,94s,93s,92s,87s,87o:0.2,86,85,84s:0.2,83s,82s,76,75,74s:0.2,73s,72s,65,64s:0.2,64o,63s:0.2,62s,54s:0.2,54o,53s:0.2,52s,43s:0.2,42s,32s';*/
    var handArray = {};
    var hands = data.split(',');
    var reg = /(.*?):(.*)/;
        var PP = ['AA', 'KK', 'QQ', 'JJ', 'TT', '99', '88', '77', '66', '55', '44', '33', '22'];
        $('.' + color).removeClass('color');
        $('.' + color + '.weighted').remove();
        for (var i = 0; i < hands.length; i++) {
            if (hands[i].indexOf(':') >= 0) {
                var reg = /(.*?):(.*)/;
                var m = hands[i].match(reg);
                var m1 = m[1];
                var handCheck;
                var width;
                var m1Stripped = m1.replace(/s/g, '');
                m1Stripped = m1Stripped.replace(/c/g, '');
                m1Stripped = m1Stripped.replace(/d/g, '');
                m1Stripped = m1Stripped.replace(/h/g, '');
                var m2 = Math.round(m[2] * 100);

                if(m1.match('s.s') || m1.match('d.d') || m1.match('h.h') || m1.match('c.c')) {
                  var selectorHand = m1Stripped+'s';
                  handArray[selectorHand] = (handArray[selectorHand] + Math.round(m2*0.25)) || Math.round(m2*0.25);
                }
                if (m1.match('s.c') || m1.match('s.d') || m1.match('s.h') || m1.match('c.s') || m1.match('c.h') || m1.match('c.d') ||
                m1.match('h.c') || m1.match('h.d') || m1.match('h.s') || m1.match('d.s') || m1.match('d.h') || m1.match('d.c')) {
                  if (PP.indexOf(m1Stripped) >= 0) {
                    var selectorHand = m1Stripped;
                    handArray[selectorHand] = (handArray[selectorHand] + Math.round(m2*0.1667)) || Math.round(m2*0.1667);
                  } else {
                    var selectorHand = m1Stripped+'o';
                    handArray[selectorHand] = (handArray[selectorHand] + Math.round(m2*0.083)) || Math.round(m2*0.083);
                  }
                }
                if(m1.match('..s') || m1.match('..o')) {
                  handCheck = $.trim(m1);
                  width = m2;
                  handArray[handCheck] = m2;
                }
                if(PP.indexOf(m1) >=0) {
                  handCheck = $.trim(m1);
                  width = m2;
                  handArray[handCheck] = m2;
                }

            } else {
                var m1 = hands[i];
                var m1Stripped;
                if (hands[i].indexOf('s') < 0 && hands[i].indexOf('o') < 0) {
                    if (PP.indexOf(hands[i]) >= 0) {
                        $('#cid_' + hands[i]).addClass(color)
                    }
                    if(m1.match('s.s') || m1.match('d.d') || m1.match('h.h') || m1.match('c.c')) {
                      m1Stripped = m1.replace(/s/g, '');
                      m1Stripped = m1Stripped.replace(/c/g, '');
                      m1Stripped = m1Stripped.replace(/d/g, '');
                      m1Stripped = m1Stripped.replace(/h/g, '');
                      $('#cid_'+m1Stripped+'s');
                    }
                    if (m1.match('s.c') || m1.match('s.d') || m1.match('s.h') || m1.match('c.s') || m1.match('c.h') || m1.match('c.d') ||
                    m1.match('h.c') || m1.match('h.d') || m1.match('h.s') || m1.match('d.s') || m1.match('d.h') || m1.match('d.c')) {
                      m1Stripped = m1.replace(/s/g, '');
                      m1Stripped = m1Stripped.replace(/c/g, '');
                      m1Stripped = m1Stripped.replace(/d/g, '');
                      m1Stripped = m1Stripped.replace(/h/g, '');
                      $('#cid_' + m1Stripped + 'o').addClass(color);
                    } else {
                        var m1o = $.trim(hands[i]) + 'o';
                        var m1s = $.trim(hands[i]) + 's';
                        $('#cid_' + m1o).addClass(color);
                        $('#cid_' + m1s).addClass(color)
                    }
                } else {
                    $('#cid_' + hands[i]).addClass(color)
                }
            }

          }
          $.each(handArray, function(selector, value) {
              var weightedDiv = $('<div>');
              weightedDiv.addClass(color + ' weighted');
              weightedDiv.attr('data-weight', value);
              weightedDiv.attr('data-hand', selector);
              weightedDiv.width(value + '%');
              var start = 0;
              $('#cid_' + handCheck).children('.weighted').each(function() {
                  start += parseFloat(this.getAttribute('data-weight'));
              });
              weightedDiv.css('left', start + '%');
            if(start + value <= 100) {
              $('#cid_' + selector).prepend(weightedDiv);
            } else {
              weightedDiv.attr('data-weight', value);
              $('#cid_' + selector).prepend(weightedDiv);
            }
          });
    this.updatePercent();
    $('#importHands').modal('hide');
}

/***** COMMMENTS ******/
  loadComments(postId) {

  }
    commentAddHtmlFunction(commentId, comment, author) {
        var html = `<div data-id="${commentId}" class="demo-card-wide mdl-card mdl-shadow--2dp comment">
                <div class="mdl-card__title">
                <div class="fp-avatar" style="background-image: url(${author.profile_picture});"></div>
                <div class="fp-username mdl-color-text--black">${author.full_name || 'Anonymous'}</div>
                </div>
                <div class="mdl-card__supporting-text">
                ${comment}
                </div>`
            if (this.auth.currentUser.uid === author.uid) {
                html += `<div class="mdl-card__menu"><a data-id="${commentId}" class="comment-edit mdl-button mdl-button--primary mdl-js-button mdl-js-ripple-effect">Edit</a><a data-id="${commentId}" class="comment-delete mdl-button mdl-button--red mdl-js-button mdl-js-ripple-effect">Delete</a>
                </div></div>`
            } else {
                html += '</div>';
            }
        $('.commentSection').append(html)
    }

    addCommentFunction() {
        $('#commentForm').modal('show');
    }
    deleteCommentFunction(commentId) {
        ranger.firebase.deleteComment(window.postKey, commentId);
    }
    saveCommentFunction() {
        if (this.commentInput.val() != '') {
        var comment = this.commentInput.val();
        this.commentInput.val('');
        ranger.firebase.addComment(window.postKey, comment);

        $('#commentForm').modal('hide');
        } else {
            var data = {
              message: 'Cannot Post A Blank Comment',
              timeout: 8000
            };
            returnToast(data, 8000);
            this.commentInput.focus();
        }
    }

  loadRange(postId) {
    ranger.auth.waitForAuth.then(() => {
    $(document).ready(() => {
      this.resetTool();
      console.log(firebase.auth.currentUser);
      var currentUser = this.auth.currentUser.uid;

      var members = {};
      //ranger.firebase.checkPostPermissions(this.auth.currentUser.uid, postId);
      window.postKey = postId;

      this.stopListeners();
      this.startListeners();
      ranger.firebase.loadRangePost(postId).then(function(data) {

          if (data.coach === true && currentUser.isPro === false) {
            alert('Upgrade to see Coaching Hands');
            page('/');
          }
          if(typeof data.members != 'undefined') {
              members = data.members;
          } else {
              members.uid = null;
          }

          if(data.author.uid === currentUser || members.uid === currentUser) {
            $('.owner').show();
          } else {
              $('.owner').hide();
          }
          $('.rangeContainer').show();
          $('.editResults').hide();
          $('#rangeTitle').val(data.text);
          $('#handTextArea').hide();
          $('.rangeTitleContainer').addClass('is-dirty');
          $('#handInfo').html(data.handHistory);
          $('#handPreview').html(data.handPreview);
          window.replayerKey = data.replayer || '';
          $('.showdown').hide();
          if (data.public) {
            $('#public_tgl_lbl').addClass('is-checked');
            $('#public_tgl').attr('checked');
          } else {
              $('#public_tgl_lbl').removeClass('is-checked');
              $('#public_tgl').removeAttr('checked');
          }
      });
      $('.filters').empty();
      ranger.firebase.loadRangeFilters(postId);//.then(function(data) {
           //$('.filters').empty();
           /*for( const key in data) {
             var rangeNotes = '';
                 if (data[key].notes) {
                   rangeNotes = data[key].notes;
                 }
                if (data[key].name) {
                  var html = '<button id="'+key+'" data-notes="'+rangeNotes+'" class="filterbtns btn btn-warning btn-sm" draggable="true" ondragstart="ranger.range.drag(event)">'+data[key].name+'</button>';
                  $('.filters').append(html);
                }
           };*/
      //});
    });
    });
  }

  addMemberHTML(userId, userName) {
    var item = $('<div/>', {class: 'mdl-list__item'});
    $('<span/>', {class: 'mdl-list__item-primary-content'}).html('<span>' + userName + '</span>').appendTo(item);
    $('<button/>', {'data-id': userId, class: "btn btn-link"}).html('<i class="material-icons">delete</i>').appendTo(item);
    $('.rangeMemberList').append(item);
  }

  clearGrid(save) {
      if (save) {
          $('.cell').removeClass(this.colors);
          $('.weighted').remove();
          ranger.firebase.saveRange(window.postKey, window.rangeKey);
          this.updatePercent();
      } else {
          $('.cell').removeClass(this.colors);
          $('.weighted').remove();
          this.updatePercent(false);
      }
  }


    /**
    * Color Selection.
    */

    changeColorName() {
        $('#colorModal').modal('show');
        this.saveColorNameInput.focus();
    }
    cancelColorName(id) {
        $('#colorModal').modal('hide');
        if(this.saveColorNameInput.val() != '') {
          var name = this.saveColorNameInput.val();
          $('#' + id).text(name);
          this.saveColorNameInput.val('');
          //Fix Problem Here
          ranger.firebase.saveRange(window.postKey, window.rangeKey);
        }
    }

    clearSelectedColour(id) {
        $('.'+id + '.weighted').remove();
        $('.cell').removeClass(id);
        ranger.firebase.saveRange(window.postKey, window.rangeKey);
        this.updatePercent();
    }

    /*** Update Post ***/
    updatePost() {
        if (this.rangeTitle.val() === '') {
            this.rangeTitle.focus();
            var data = {
              message: 'Please add a title for the hand / range',
              timeout: 8000
            };
            returnToast(data, 8000);
        } else {
            ranger.firebase.updateTitle(window.postKey, this.rangeTitle.val());
            ranger.firebase.saveHandHistory(window.postKey, $('#handInfo').html(), $('#handPreview').html());
        }
    }

    /*** Add Filter Button ***/
    newFilterButton() {
        //var role = ranger.MaterialUtils.checkRole();
        //role.then(function(data) {
            if(this.auth.currentUser.isPro === true) {
                $('#filterNameForm').modal('show');
                $('#updateFilter').hide();
                $('#duplicateFilter').hide();
                $('#saveFilter').show();
                $('#filterInput').focus();
            } else {
                ranger.MaterialUtils.upgrade();
            }
          //});
    }
    cancelFilterButton() {
        $('#filterNameForm').modal('hide');
    }
    saveFilterButton(update = false) {

            if (this.filterName.val() != '') {
                var name = this.filterName.val();
                this.filterName.val('');
                if (update === false) {
                    this.saveRangeBtn.show();
                    this.shareRange.show();
                    window.rangeKey = ranger.firebase.addRangeFilter(window.postKey, name);
                    $('.filterbtns').removeClass('selectedFilter');
                    //var html = '<button id="'+window.rangeKey+'" class="filterbtns btn btn-sm btn-warning selectedFilter" draggable="true" ondragstart="ranger.range.drag(event)">'+name+'</button>';
                    $('#filterNameForm').modal('hide');
                    $('.rangeContainer').show();
                    //$('.filters').append(html);
                    this.clearGrid();
                    ranger.firebase.saveRange(window.postKey, window.rangeKey);
                } else {
                    $('#filterNameForm').modal('hide');
                    $('#'+window.rangeKey).text(name);
                    ranger.firebase.saveRange(window.postKey, window.rangeKey, name);
                }
            } else {
                var data = {
                  message: 'Please Enter Range Name',
                  timeout: 8000
                };
                returnToast(data, 8000);
                this.filterName.focus();
            }
    }
    duplicateFilter() {

        if (this.filterName.val() != '') {
            var name = this.filterName.val();
            var newKey = ranger.firebase.duplicateFilter(window.postKey, window.rangeKey, name);
            $('.filterbtns').removeClass('selectedFilter');
            //var html = '<button id="'+newKey+'" class="filterbtns btn btn-sm btn-warning" draggable="true" ondragstart="ranger.range.drag(event)">'+name+'</button>';
            $('#filterNameForm').modal('hide');
            //Fix with listener
            $('#'+newKey).text(name).addClass('selectedFilter');
            this.filterName.val('');
        } else {
            var data = {
              message: 'Please Enter Range Name',
              timeout: 8000
            };
            returnToast(data, 8000);
            this.filterName.focus();
        }
    }

    deleteRange() {
        swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this range!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'Yes, delete it!',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
          allowEscapeKey: true
        }, () => {
          ranger.firebase.deleteRange(window.postKey, window.rangeKey).then(() => {
            swal({
              title: 'Deleted!',
              text: 'Your range has been deleted.',
              type: 'success',
              timer: 2000
            });
            $('#'+window.rangeKey).remove();
            this.clearGrid();
          }).catch(error => {
            swal.close();
            const data = {
              message: `There was an error deleting your range: ${error}`,
              timeout: 5000
            };
            returnToast(data,8000);
          });
        });
    }

  /**
   * Update Percent.
   */
  updatePercent(save = true, subset = false) {
      if(subset) {
        var suitedInv = $('.invisible.s').length * 4;
        var offInv = $('.invisible.o').length * 12;
        var ppInv = $('.invisible.p').length  * 6 ;
        var subsetRange = suitedInv + offInv + ppInv;
        console.log(subsetRange);
      } else {
        var subsetRange = 0;
      }
      this.isMouseDown = false;

      this.combosBreakDown.empty();
      var cardRemoval = 0;

      var suited = ($('.mdl-color--green.s').length +  $('.mdl-color--amber.s').length + $('.mdl-color--red.s').length + $('.mdl-color--blue.s').length + $('.mdl-color--lime.s').length + $('.mdl-color--cyan.s').length + $('.mdl-color--brown.s').length + $('.mdl-color--grey.s').length + $('.mdl-color--teal.s').length + $('.mdl-color--indigo.s').length + $('.mdl-color--purple.s').length +  $('.mdl-color--pink.s').length + $('.mdl-color--light-green.s').length + $('.mdl-color--orange.s').length + $('.mdl-color--deep-orange.s').length + $('.mdl-color--deep-purple.s').length) * 4 ;

      var offsuit = ($('.mdl-color--green.o').length +  $('.mdl-color--amber.o').length + $('.mdl-color--red.o').length + $('.mdl-color--blue.o').length + $('.mdl-color--lime.o').length + $('.mdl-color--cyan.o').length + $('.mdl-color--brown.o').length + $('.mdl-color--grey.o').length + $('.mdl-color--teal.o').length + $('.mdl-color--indigo.o').length + $('.mdl-color--purple.o').length +  $('.mdl-color--pink.o').length + $('.mdl-color--light-green.o').length + $('.mdl-color--orange.o').length + $('.mdl-color--deep-orange.o').length + $('.mdl-color--deep-purple.o').length) * 12;

      var pp = ($('.mdl-color--green.p').length +  $('.mdl-color--amber.p').length + $('.mdl-color--red.p').length + $('.mdl-color--blue.p').length + $('.mdl-color--lime.p').length + $('.mdl-color--cyan.p').length + $('.mdl-color--brown.p').length + $('.mdl-color--grey.p').length + $('.mdl-color--teal.p').length + $('.mdl-color--indigo.p').length + $('.mdl-color--purple.p').length +  $('.mdl-color--pink.p').length + $('.mdl-color--light-green.p').length + $('.mdl-color--orange.p').length + $('.mdl-color--deep-orange.p').length + $('.mdl-color--deep-purple.p').length) * 6;

      var weightedCombos = ranger.MaterialUtils.countWeightedCombos();

      var totalSelected = Math.round(suited + offsuit + pp + weightedCombos.total);

      var counts = [];
      for (var i = 0; i < window.removal.length; i++) {
          if(counts[window.removal[i]] === undefined) {
              counts[window.removal[i]] = 1;
          } else {
            counts[window.removal[i]]++;
          }
      }

      //Card Removal Code Here
      this.colorArray.forEach(function(color) {
        window.removal.forEach(function(i) {
          $('.'+color+'.p').each(function(index, hand) {
            if ($(this).text().indexOf(i) > -1) {
              if(counts[i] === 1) {
                cardRemoval += 3;
              } else if (counts[i] === 2) {
                cardRemoval += 2.5;
              } else if (counts[i] > 2) {
                cardRemoval += 2;
              }
            }
          });

          $('.'+color+'.o').each(function(index, hand) {
            var hand = $(this).text();
            var handOne = hand.substring(0,1);
            var handTwo = hand.substring(1,2);

            if ($(this).text().indexOf(i) > -1) {
              if(window.removal.indexOf(handOne) > -1 && window.removal.indexOf(handTwo) > -1) {
                cardRemoval +=2.5;
              } else {
                cardRemoval += 3;
              }
            }
          });

          $('.'+color+'.s').each(function(index, hand) {
            if ($(this).text().indexOf(i) > -1) {
              //Handle Suited Combos (only remove once)
              cardRemoval += 1;
            }
          });
        })
      });
      cardRemoval = Math.floor(cardRemoval);
      var totalCombosRemoval = 1326 - cardRemoval;
      var totalSelectedRemoval = totalSelected - cardRemoval;

      var percentSelected = ( totalSelected / (1326 - subsetRange)) * 100;
      var removalsPercent = (totalSelectedRemoval / (totalCombosRemoval - subsetRange)) * 100;
      $('.selectedItems').text(percentSelected.toFixed(1) + "% of hands");
      $('.totalCombos').text('('+ totalSelected +' combos)');
      $('.removalItems').text(removalsPercent.toFixed(1) + "% of hands");
      $('.removalCombos').text('('+totalSelectedRemoval+ ' combos w/ Removal)');


      this.percentBreakDown('.mdl-color--green', totalSelected, 'mdl-color--green text-white', weightedCombos.category1);
      this.percentBreakDown('.mdl-color--amber', totalSelected, 'mdl-color--amber text-white', weightedCombos.category2);
      this.percentBreakDown('.mdl-color--red', totalSelected, 'mdl-color--red text-white', weightedCombos.category3);
      this.percentBreakDown('.mdl-color--blue', totalSelected, 'mdl-color--blue text-white', weightedCombos.category4);
      this.percentBreakDown('.mdl-color--lime', totalSelected, 'mdl-color--lime text-white', weightedCombos.category5);
      this.percentBreakDown('.mdl-color--cyan', totalSelected, 'mdl-color--cyan text-white', weightedCombos.category6);
      this.percentBreakDown('.mdl-color--brown', totalSelected, 'mdl-color--brown text-white', weightedCombos.category7);
      this.percentBreakDown('.mdl-color--grey', totalSelected, 'mdl-color--grey text-white', weightedCombos.category8);
      this.percentBreakDown('.mdl-color--teal', totalSelected, 'mdl-color--teal text-white', weightedCombos.category9);
      this.percentBreakDown('.mdl-color--indigo', totalSelected, 'mdl-color--indigo text-white', weightedCombos.category10);
      this.percentBreakDown('.mdl-color--purple', totalSelected, 'mdl-color--purple text-white', weightedCombos.category11);
      this.percentBreakDown('.mdl-color--pink', totalSelected, 'mdl-color--pink text-white', weightedCombos.category12);
      this.percentBreakDown('.mdl-color--light-green', totalSelected, 'mdl-color--light-green text-white', weightedCombos.category13);
      this.percentBreakDown('.mdl-color--orange', totalSelected, 'mdl-color--orange text-white', weightedCombos.category14);
      this.percentBreakDown('.mdl-color--deep-orange', totalSelected, 'mdl-color--deep-orange text-white', weightedCombos.category15);
      this.percentBreakDown('.mdl-color--deep-purple', totalSelected, 'mdl-color--deep-purple text-white', weightedCombos.category16);

      if(save) {
        ranger.firebase.saveRange(window.postKey, window.rangeKey);
      }

  }

  /**
   * Calculate Combos.
   */
  percentBreakDown (selector, total, color, weighted) {
      var combos = ($(selector + '.s').length * 4) + ($(selector + '.o').length * 12) + ($(selector + '.p').length * 6);
          var id = selector;
          id = id.replace('.', '');
      var totalCombos = parseInt(combos) + parseInt(weighted);
      if ((combos+weighted) > 0) {
      var breakdown = ((combos + weighted) / total) * 100;
      } else {
          $('#' + id).html('<i class="material-icons">add</i>');
          breakdown = 0;
      }
      //$('div[data-mdl-for="' + id + '"]').html(breakdown.toFixed(2) + '% (' + totalCombos + ')');
      $('#' + id).attr('title', breakdown.toFixed(2) + '% (' + totalCombos + ')');
      $('.combosBreakdown').append('<li class="mdl-list__item ' + color + '">' + breakdown.toFixed(2) + '% (' + totalCombos + ')</li>');
  }

  formatHand() {
      var handText = this.handTextArea.val();
      var parsedHand = ranger.parse.parseHand(handText.split('\n'));

      /*handText = handText.replace(/\$/g,"");
      //handText = handText.replace(/\.\d+/g, "");

      handText = handText.replace(/\USD/g, "");
      handText = handText.replace(/\out of hand (moved from another table into small blind)/g, "");
      handText = handText.replace(/\u20ac/g, "");
      handText = handText.replace(/\€/g, "");
      handText = handText.replace(/^.*? will be allowed to play after the button/g, "")
			handText = handText.replace(/^.*? is sitting out\n/mg, "");
			handText = handText.replace(/^.*? has returned\n/mg, "");
			handText = handText.replace(/^.*?: doesn't show hand\n/mg, "");
			handText = handText.replace(/^.*? mucks hand \n/mg, "");
			handText = handText.replace(/^.*? said, "(.*?)"\n/mg, "");
			handText = handText.replace(/^Uncalled bet \(.*?\) returned to (.*)/mg, "");
      if (handText.indexOf('PokerStars') != -1 || handText.indexOf('Pokerstars') !=-1) {
        handText = handText.replace(/\$/g,"");
        handText = handText.replace(/\USD/g, "");
        handText = handText.replace(/\out of hand (moved from another table into small blind)\n/mg, "");
        handText = handText.replace(/\u20ac/g, "");
        handText = handText.replace(/\€/g, "");
        handText = handText.replace(/\Ä/g, "");
        handText = handText.replace(/,/g, '');
      }
      if (handText.match('NL Texas Hold\'em')) {
        handText = handText.replace(/.*? has joined the table\n/mg, "");
        handText = handText.replace(/Player (.*?) has been moved from .*\n/mg, "");
        handText = handText.replace(/^.*? will be using their time bank for this hand\.\n/mg, '');
        handText = handText.replace(/There will be a break in 4 minute(s)\n/mg, '');
        handText = handText.replace(/.*? did not respond in time\n/mg, '');
        handText = handText.replace(/Your time bank will be activated in .*\n/mg, '');
        handText = handText.replace(/There is no Small Blind .*\n/mg, '');
        //handText = handText.replace(/^.*: ./////**g, '');
        //handText = handText.replace(/^\s+|\s+$/gm, '');
      }*/

      if (handText.startsWith("https://") || handText.startsWith("http://")) {
        var $container = $("<div>", {class: "mdl-card"});
        var $heading = '<div class="mdl-card__title mdl-color--orange"><h6 class="mdl-card__title-text">External Hand</h6></div>';
        var $link = '<div class="mdl-card__supporting-text"><a href="' + handText + '" target="_blank"><h5>View Hand</h5></a></div>';
        if (handText.startsWith("https://www.weaktight.com/h")) {
          //WeakTight|| handText.startsWith("https://weaktight.com")
          var externalPreview = `<div class="fp-handhistory"><div class="fp-handhistory"><div><span class="flop-block">WeakTight Hand</span><hr><div class="heroHolder"><img class="externalHand" src="/images/weak.png"/></div></div></div></div>`;
        } else if (handText.startsWith("https://www.boomplayer.com/")) {
          //boomplayer
          var externalPreview = `<div class="fp-handhistory"><div class="fp-handhistory"><div><span class="flop-block">Boom Player Hand</span><hr><div class="heroHolder"><img class="externalHand" src="/images/boom.png"/></div></div></div></div>`;
        } else {
          var externalPreview = `<div class="fp-handhistory"><div class="fp-handhistory"><div><span class="flop-block">External Hand Link</span><hr><div class="heroHolder"><img class="externalHand" src="/images/external.png"/></div></div></div></div>`;
        }

        $container.append($link);
        $container.prepend($heading);
        $('#handInfo').html($container);
        $('#handPreview').html(externalPreview);
        this.handTextArea.val('');
        this.handTextArea.hide();
        ranger.firebase.saveHandHistory(window.postKey, $('#handInfo').html(), $('#handPreview').html());
      } else {

      try {
          //PokerHistoryParser(handText)
          ranger.prettyHand.convertToReadable(parsedHand);
      } catch (e) {
          swal(
          'Oops...',
          'Invalid Format, we have noted the error and will resolve.',
          'error'
          )
          ranger.firebase.saveErrorHistory(handText);
          this.handTextArea.val('');
      } finally {
          //var result = PokerHistoryParser(handText);
          $('#handInfo').html('');
          $('#handPreview').html('');
          this.handTextArea.val('').hide();
          /*
          try {
              ranger.range.visualizeHand(result);
          } catch (e) {
              ranger.firebase.saveErrorHistory(handText);
              $('#handInfo').html(handText);
          }
          fetch('https://us-central1-crushwithus-70cb5.cloudfunctions.net/postReplayerHand', {
            headers: {
              'Content-Type': 'text/plain'
            },
            method: 'POST',
            body: handText
          }).then(res => {
            res.json().then(json => {
              var postData = json;
              if(postData.postKey != null) {
                window.replayerKey = postData.postKey;
                ranger.firebase.saveHandHistory(window.postKey, $('#handInfo').html(), $('#handPreview').html(), handText, postData.postKey);
              }
            });
          })*/
          ranger.prettyHand.convertToReadable(parsedHand);
          ranger.firebase.saveHandHistory(window.postKey, $('#handInfo').html(), $('#handPreview').html(), handText, '');
      }
    }

  }

  visualizeHand (handHistory) {
  /** Build Parsed Hand **/
      var $heading = '<h6 class="mdl-card__title-text">' + handHistory.settings.platform + '</h6>';
      var $ante = '';
      if (handHistory.settings.ante != 0) {
          $ante = handHistory.settings.ante + ' ante';
      }
      var $blinds = '<h5>Blinds ' + handHistory.settings.blind.small + '/' + handHistory.settings.blind.big + ' ' + $ante + '</h5>';

      var $preview = $('<div>');

      var showCards = function(hand, preview = false) {
        var formattedHand;
        if (preview != false) {
            if ( hand.match(/c/g) ) {
            formattedHand = '<div class="card mdl-color--green"><span class="corner">'+hand.replace(/c/g, '')+'</span>';
            formattedHand += '<span class="suit clubs"></span><span class="middle">'+hand.replace(/c/g,'')+'</span></div>';
            } else if (hand.match(/h/g)) {
            formattedHand = '<div class="card mdl-color--red"><span class="corner">'+hand.replace(/h/g, '')+'</span>';
            formattedHand += '<span class="suit hearts"></span><span class="middle">'+hand.replace(/h/g,'')+'</span></div>';
            } else if (hand.match(/d/g) ) {
            formattedHand = '<div class="card mdl-color--blue"><span class="corner">'+hand.replace(/d/g, '')+'</span>';
            formattedHand += '<span class="suit diamonds"></span><span class="middle">'+hand.replace(/d/g,'')+'</span></div>';
            } else if (hand.match(/s/g)) {
            formattedHand = '<div class="card mdl-color--grey"><span class="corner">'+hand.replace(/s/g, '')+'</span>';
            formattedHand += '<span class="suit spades"></span><span class="middle">'+hand.replace(/s/g,'')+'</span></div>';
            }
            return formattedHand;
        } else if (hand != '' || hand != undefined) {
        if ( hand.match(/c/g) ) {
            formattedHand = '<span class="cards mdl-color-text--green">' + hand.replace(/c/g, '<img src="/images/club.png">') + '</span>';
        } else if (hand.match(/h/g)) {
            formattedHand = '<span class="cards mdl-color-text--red">' + hand.replace(/h/g, '<img src="/images/heart.png">') + '</span>';
        } else if (hand.match(/d/g) ) {
            formattedHand = '<span class="cards mdl-color-text--blue">' + hand.replace(/d/g, '<img src="/images/diamond.png">') + '</span>';
        } else if (hand.match(/s/g)) {
            formattedHand = '<span class="cards mdl-color-text--grey">' + hand.replace(/s/g, '<img src="/images/spade.png">') + '</span>';
        }
         return formattedHand;
        } else {
         return '';
        }
      }

      var convertBB = function(chips) {
          if (chips === undefined || chips === 0) {
              return '';
          }
          return Math.round((parseFloat(chips) / parseFloat(handHistory.settings.blind.big))*100)/100 + 'bb';
      }

      var $handInfo = $("<div>", {id: "hhTitle", class: "mdl-card__title"});

      var $container = $("<div>", {class: "mdl-card"});
      var $players = $("<div>", {id: "players", class: "mdl-card__supporting-text"});
      var $player;

      var $playerCount = 0;


      var $preflop = $("<div>", {id: "preflop", class: "mdl-card__supporting-text"});
      var $preflopPlayer;

      var $flop = $("<div>", {id: "flop", class: "mdl-card__supporting-text"});
      var $flopActions;
      var $flopCard;

      var $turn = $("<div>", {id: "turn", class: "mdl-card__supporting-text"});

      if(handHistory.cards.TURN) {
        var $turnCard = $("<li class='inline-block'>").html(showCards(handHistory.cards.TURN[0]));
      }

      var $turnActions = $("<ul>", {id: "turnActions", class: "mdl-list"});
      var $turnAction;


      var $river = $("<div>", {id: "river", class: "mdl-card__supporting-text"});
      if(handHistory.cards.RIVER) {
        var $riverCard = $("<li class='inline-block'>").html(showCards(handHistory.cards.RIVER[0]));
      }

      var $showdown = $('<div>', {id: 'showdown', class: 'mdl-card__supporting-text'});
      var $showdownActions;

      for (var j=0; j<handHistory.actions.showdown.length; j++) {
          $showdownActions = $('<span>', {class: 'showdown'});
          if (handHistory.actions.showdown[j].username === handHistory.me.username) {
              $showdownActions.addClass('hero');
              $showdownActions.html(handHistory.actions.showdown[j].username + ' shows ' + showCards(handHistory.actions.showdown[j].cards[0]) + '  ' + showCards(handHistory.actions.showdown[j].cards[1]) + ' ' + handHistory.actions.showdown[j].finalHand + '<br />');
          } else {
              $showdownActions.html(handHistory.actions.showdown[j].username + ' shows ' + showCards(handHistory.actions.showdown[j].cards[0]) + '  ' + showCards(handHistory.actions.showdown[j].cards[1]) + ' ' + handHistory.actions.showdown[j].finalHand + '<br />');
          }
          $showdown.append($showdownActions);
      }
      $showdown.prepend('<h5>Show Down</h5>');

      var $riverActions = $("<ul>", {id: "riverActions", class: "mdl-list"});
      var $riverAction;

      for(var i = 0; i < handHistory.players.length; i++){
        var $name;
        $player = $("<li>", {class: "mdl-list__item"});
          if (handHistory.players[i].username === handHistory.me.username) {
              handHistory.players[i].username = '<span class="hero">' + handHistory.players[i].username + '</span>';
          }
          if (handHistory.players[i].bounty === 0) {
              var $bounty = '';
          } else {
            var $bounty = ' (' + handHistory.players[i].bounty + ')';
          }
          var $formattedChips = parseFloat(handHistory.players[i].chips).toLocaleString('en');
          var $bigBlinds = Math.round(parseFloat(handHistory.players[i].chips) / parseFloat(handHistory.settings.blind.big));

        $player.html('<span class="inline-block">' + handHistory.players[i].position + '</span><span class="inline-block big"> ' + handHistory.players[i].username + '</span><span class="inline-block big">' + $bigBlinds + 'bb ' + $bounty + '</span>');
        $players.append($player);
      }


      for(var j = 0; j < handHistory.actions.preflop.length; j++){
        $preflopPlayer = $("<span>", {class: "actions"});
        if (handHistory.actions.preflop[j].type === 'RAISE' || handHistory.actions.preflop[j].type === 'CALL' || handHistory.actions.preflop[j].type === 'CHECKS' || handHistory.actions.preflop[j].type === 'BET') {
            if ($playerCount > 0) {
                $preflop.append("<span class='actions'>" + $playerCount + ' folds');
                $playerCount = 0;
            }
            if (handHistory.actions.preflop[j].username === handHistory.me.username) {
                $preflopPlayer.html('<span class="hero">' + handHistory.actions.preflop[j].username + ' ' + handHistory.actions.preflop[j].type + ' <span class="amt">' + (convertBB(handHistory.actions.preflop[j].total) || '') + '</span></span>');
            } else {
                $preflopPlayer.html(handHistory.actions.preflop[j].username + ' ' + handHistory.actions.preflop[j].type + ' <span class="amt">' + (convertBB(handHistory.actions.preflop[j].total) || '') + '</span>');
            }

            $preflop.append($preflopPlayer);
        } else  if (handHistory.actions.preflop[j].type === 'FOLD') {
            $playerCount++;
        }
      }

      if(typeof handHistory.cards.FLOP != 'undefined') {
      for(var j = 0; j < handHistory.cards.FLOP.length; j++){
        $flopCard = $("<li>", {class: "inline-block"});
        //handHistory.cards.FLOP[j] = showCards(handHistory.cards.FLOP[j]);
        $flopCard.html(showCards(handHistory.cards.FLOP[j]));
        //$flop.append($flopCard);
      }

      for(var j = 0; j < handHistory.actions.flop.length; j++){
        $flopActions = $("<span>", {class: "actions"});
        if(handHistory.actions.flop[j].username === handHistory.me.username) {
            $flopActions.html('<span class="hero">' + handHistory.actions.flop[j].username + ' ' + handHistory.actions.flop[j].type + ' <span class="amt">' + (convertBB(handHistory.actions.flop[j].total) || '') + '</span></span>');
        } else {
            $flopActions.html(handHistory.actions.flop[j].username + ' ' + handHistory.actions.flop[j].type + ' <span class="amt">' + (convertBB(handHistory.actions.flop[j].total) || '') + '</span>');
        }
        if (handHistory.actions.flop[j].type === 'FOLD') {
            $playerCount++;
        }
        $flop.append($flopActions);
      }
      }

if (typeof handHistory.cards.TURN != 'undefined') {
      for(var j = 0; j < handHistory.actions.turn.length; j++){
        $turnAction = $("<span>", {class: "actions"});
          if(handHistory.actions.turn[j].username === handHistory.me.username) {
            $turnAction.html('<span class="hero">' + handHistory.actions.turn[j].username + ' ' + handHistory.actions.turn[j].type + ' <span class="amt">' + (convertBB(handHistory.actions.turn[j].total) || '') + '</span></span>');
          } else {
              handHistory.actions.turn[j].username
            $turnAction.html(handHistory.actions.turn[j].username + ' ' + handHistory.actions.turn[j].type + ' <span class="amt">' + (convertBB(handHistory.actions.turn[j].total) || '') + '</span>');
          }
          if (handHistory.actions.turn[j].type === 'FOLD') {
              $playerCount++;
          }
        $turn.append($turnAction);
      }
    }

if (typeof handHistory.cards.RIVER != 'undefined') {
       for(var j = 0; j < handHistory.actions.river.length; j++){
        $riverAction = $("<span>", {class: "actions"});
        if(handHistory.actions.river[j].username === handHistory.me.username) {
            $riverAction.html('<span class="hero">' + handHistory.actions.river[j].username + ' ' + handHistory.actions.river[j].type + ' <span class="amt">' + (convertBB(handHistory.actions.river[j].total) || '') + '</span></span>');
        } else {
            $riverAction.html(handHistory.actions.river[j].username + ' ' + handHistory.actions.river[j].type + ' <span class="amt">' + (convertBB(handHistory.actions.river[j].total) || '') + '</span>');
        }
        $river.append($riverAction);
      }
    }

      $handInfo.prepend($heading);

      $preflop.prepend('<h5>Preflop</h5>');

      $players.prepend('<h5>' + handHistory.players.length + ' Players</h5>');
      $players.prepend($blinds);
if (typeof handHistory.cards.FLOP != 'undefined') {
      $flop.prepend('<span class="streetInfo"><i class="material-icons">person</i>'+(handHistory.players.length - $playerCount)+ '</span><span class="mdl-color-text--light-green">' + convertBB(handHistory.money.flopPot) + '</span> ' + showCards(handHistory.cards.FLOP[0]) + showCards(handHistory.cards.FLOP[1]) + showCards(handHistory.cards.FLOP[2]) + '<br />');
      $flop.prepend('<h5>Flop</h5>');
}

if (typeof handHistory.cards.TURN != 'undefined') {
      $turn.prepend('<span class="streetInfo"><i class="material-icons">person</i>'+(handHistory.players.length - $playerCount)+ '</span><span class="mdl-color-text--light-green">' + convertBB(handHistory.money.turnPot) + '</span> ' + showCards(handHistory.cards.FLOP[0]) + showCards(handHistory.cards.FLOP[1]) + showCards(handHistory.cards.FLOP[2]) + showCards(handHistory.cards.TURN[0]) + '<br />')
      $turn.prepend('<h5>Turn</h5>');
}

if (typeof handHistory.cards.RIVER != 'undefined') {
      $river.prepend('<span class="streetInfo"><i class="material-icons">person</i>'+(handHistory.players.length - $playerCount)+ '</span><span class="mdl-color-text--light-green">' + convertBB(handHistory.money.riverPot) + '</span> ' + showCards(handHistory.cards.FLOP[0]) + showCards(handHistory.cards.FLOP[1]) + showCards(handHistory.cards.FLOP[2]) + showCards(handHistory.cards.TURN[0]) + showCards(handHistory.cards.RIVER[0]) + '<br />')
      $river.prepend('<h5>River</h5>');
    }

      $container.append($handInfo);
      $container.append($players);
      //Heros Hand
      var $hero = $("<div>", {id: "hero", class: "mdl-card__supporting-text"});
      $hero.append("<h5>Hero</h5>");
      $hero.append(showCards(handHistory.me.cards[0]) + '  ' + showCards(handHistory.me.cards[1]));
      $container.append($hero);
      $container.append($preflop);

      $container.append($flop);


      $container.append($turn);
      $container.append($river);
      $container.append($showdown);

      if (typeof handHistory.cards.FLOP != 'undefined') {
      for (var j = 0; j < handHistory.cards.FLOP.length; j++) {
          $preview.append('<span class="flop-block">' + showCards(handHistory.cards.FLOP[j], true) + '</span>');
      }
      }
      if (typeof handHistory.cards.TURN != 'undefined'){
          $preview.append('<span class="flop-block">' + showCards(handHistory.cards.TURN[0], true) + '</span>');
      }
      if (typeof handHistory.cards.RIVER != 'undefined') {
          $preview.append('<span class="flop-block">' + showCards(handHistory.cards.RIVER[0], true) + '</span>');
      }
      $preview.append('<hr />');
      $preview.append('<div class="heroHolder">' + showCards(handHistory.me.cards[0], true) + ' ' + showCards(handHistory.me.cards[1], true) + '<div class="starsBottom"><span>'+handHistory.me.username+'</span><span></span></div></div><br />');


      $("#handInfo").append($container);
      $("#handPreview").append($preview);
      componentHandler.upgradeDom();
  }

  compareRanges() {
    this.compareRangeForm.toggle();
  }

  calculateEquity() {
    var $player1 = $('#heroRange').val();
    $player1 = $player1.replace(/\s/g, '');
    var $player2 = $('#villainRange').val();
    $player2 = $player2.replace(/\s/g, '');
    var $board = $('#board').val();
    $board = $board.trim();

    $('#loading').show();

    window.worker.onmessage = function(e) {
      $('#loading').hide();
      var heroEquity = (e.data.results[0]._winShares + e.data.results[0]._tieShares) / e.data.ttl * 100;
      var villainEquity = (e.data.results[1]._winShares + e.data.results[1]._tieShares) / e.data.ttl * 100;

      $('#heroEquity').text('Hero Equity ' + heroEquity.toFixed(2) + '%');
      $('#villainEquity').text('Villain Equity ' + villainEquity.toFixed(2) + '%');
    }

    window.worker.postMessage([$player1, $player2, $board]);
  }

  createRange() {

      ranger.firebase.createNewRange(window.postKey)
          .then(postId => {
            page(`/`);
            var data = {
              message: 'Hand has been posted!',
              actionHandler: `/viewPost/${postId}`,
              actionText: 'View',
              timeout: 10000
            };
            returnToast(data, 8000, true);
            this.addButton.prop('disabled', false);
            this.resetTool();
          }, error => {
            console.error(error);
            var data = {
              message: `There was an error while posting your hand. Sorry!`,
              timeout: 5000
            };
            returnToast(data, 5000);
            this.addButton.prop('disabled', false);
            this.resetTool();
          });
  }

};

ranger.range = new ranger.Range();
